<div class="p-4 shadow-md rounded-lg font-poppins flex flex-col gap-4 max-h-[300px]" [style.background]="background">
	<div>
		<h3 [style.color]="color" class="font-medium text-xl mb-4">{{ title }}</h3>
	</div>
	<div class="flex justify-between items-center">
		<h2 [style.color]="color" class="font-semibold text-4xl md:text-6xl">{{ value }}</h2>
		<span class="material-symbols-rounded mr-1 opacity-20 self-center"
			style="height: 80px; width: 80px; font-size: 80px">{{ icon }}</span>
	</div>
</div>